var t = require('i18n').t
var translationExists = require('../utils/translation-exists').translationExists

// Kept out of Lokalise: some encoding issues supposedly preventing syncing
var COMPLETE_BOOKKEEPING_LINKS = {
    'complete_bookkeeping.accruals': 'https://billy.dk/support/article/kontrol-af-periodiseringer/',
    'complete_bookkeeping.control_salary': 'https://billy.dk/support/article/kontrol-af-l%C3%B8nbogf%C3%B8ring/?source=algolia&queryID=ccc6326bfd326e574fe04bc91c875bdd',
    'complete_bookkeeping.primo_reconciliation': 'https://billy.dk/support/article/lav-en-primoafstemning/',
    'complete_bookkeeping.reconcile_bank': 'https://billy.dk/support/article/afstem-banken-til-aarsafslutning/',
    'complete_bookkeeping.reconcile_intermediates': 'https://billy.dk/support/article/afstem-mellemregninger-med-indehaver/',
    'complete_bookkeeping.reconcile_payables': 'https://billy.dk/support/article/afstemning-af-forpligtelser/',
    'complete_bookkeeping.reconcile_receivables': 'https://billy.dk/support/article/afstemning-af-tilgodehavender/'
}

module.exports = require('./abstract-annual-report').extend({
    model: function() {
        var model = this.modelFor('annual_report')

        model = Object.assign({
            todos: this.get('annualReport').getCompleteBookkeepingItems(model.commitment),
            missingAccounts: this.get('annualReport').getMissingAccounts(model.commitment)
        }, model)

        return Em.RSVP.hash(model)
    },

    afterModel: function(model) {
        return model.todos.map(function(item) {
            item.strongTitle = t('annual_report.todo_list.' + item.translationKey + '.strong_title')
            item.hasStrongTitle = translationExists(item.strongTitle)
            item.title = t('annual_report.todo_list.' + item.translationKey + '.title')
            item.link = COMPLETE_BOOKKEEPING_LINKS[item.translationKey]
            item.hasLink = Boolean(item.link)
            item.description = t('annual_report.todo_list.' + item.translationKey + '.description')
            item.hasDescription = translationExists(item.description)

            return item
        })
    },

    setupController: function(controller, model) {
        controller.set('model', model)
        controller.set('todos', model.todos)
        controller.set('steps', model.steps)
        controller.set('currentStep', model.currentStep)
        controller.set('missingAccounts', model.missingAccounts)
    }
})
